import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {
  DialogAction,
  DialogBody,
  DialogCheckbox,
  DialogText
} from '../../dashboard/styles';
import {DELETE_MODAL} from '../../../../store/menuEditorModals/action';
import ButtonPrimary from '../../../../components/buttons/ButtonPrimary/styles';
import {setWarningNote} from '../../../../helpers/localStorage/MenuEditorNote';
import {DELETE_CATEGORY} from '../../../../store/menuEditorCategory/action';
import {DELETE_ITEM} from '../../../../store/menuEditorItems/action';
import {DELETE_MODIFIER_GROUP} from '../../../../store/menuEditorModifierGroups/action';
import {DELETE_MODIFIER} from '../../../../store/menuEditorModifier/action';
import DialogContainer from '../../../../components/DialogContainer/styles';
import DialogClose from '../../../../components/DialogClose/styles';
import DialogTitle from '../../../../components/DialogTitle/styles';
import CheckboxContainer from '../../../../components/Checkbox/styles';
import sendGtmEvent from '../../../../helpers/services/utils/gtm';

const DeleteModal = () => {
  const dispatch = useDispatch();
  const {modalNoteEntityName, isDeleteModalOpen} = useSelector(
    (state) => state.menuEditorModalsReducer
  );
  const [checked, setChecked] = useState(false);

  const handleChangeCheckbox = () => {
    setChecked((prev) => !prev);
    setWarningNote('showDeleteNote', checked);
  };

  const submitAction = () => {
    if (modalNoteEntityName === 'category') {
      dispatch(DELETE_CATEGORY());
      sendGtmEvent('menuEditorEntityDeleted', {
        entity: 'category'
      });
    }

    if (modalNoteEntityName === 'item') {
      dispatch(DELETE_ITEM());
      sendGtmEvent('menuEditorEntityDeleted', {
        entity: 'item'
      });
    }

    if (modalNoteEntityName === 'modifier') {
      dispatch(DELETE_MODIFIER());
      sendGtmEvent('menuEditorEntityDeleted', {
        entity: 'modifier'
      });
    }

    if (modalNoteEntityName === 'modifierGroup') {
      dispatch(DELETE_MODIFIER_GROUP());
      sendGtmEvent('menuEditorEntityDeleted', {
        entity: 'modifierGroup'
      });
    }

    dispatch(DELETE_MODAL({open: false}));
  };
  return (
    <Dialog
      onClose={() => dispatch(DELETE_MODAL({open: false}))}
      open={isDeleteModalOpen}
      scroll='body'
    >
      <DialogContainer className='DialogSm'>
        <DialogClose onClick={() => dispatch(DELETE_MODAL({open: false}))} />
        <DialogTitle className='DialogTitleOrange'>Please note:</DialogTitle>
        <DialogBody>
          <DialogText className='DialogTextSm'>
            This {modalNoteEntityName} will be deleted across the entire menu.
          </DialogText>
          <DialogCheckbox>
            <CheckboxContainer>
              <FormControlLabel
                className='Say2EatCheckbox'
                control={
                  <Checkbox
                    labelStyle={{color: '#172751'}}
                    iconStyle={{fill: '#FF2D38'}}
                    inputStyle={{color: '#FF2D38'}}
                    style={{color: '#FF2D38'}}
                    onChange={handleChangeCheckbox}
                    name='checkedNote'
                    checked={checked}
                  />
                }
                label='Don’t show this message again'
              />
            </CheckboxContainer>
          </DialogCheckbox>
          <DialogAction>
            <ButtonPrimary onClick={() => submitAction()}>
              <span>OK</span>
            </ButtonPrimary>
          </DialogAction>
        </DialogBody>
      </DialogContainer>
    </Dialog>
  );
};

export default DeleteModal;
